module.exports = __webpack_public_path__ + "public/images/reviews/review-eugenia.21aae2209759898a8ba06699bc753699.png";